module.exports = __webpack_public_path__ + "static/media/6194.c2675d9e.jpg";